export default __webpack_public_path__ + "static/media/union-1.ebf496bd.svg";